import { useEffect, useState } from 'react';
import apiService from '@/api-service';

interface BestekStats {
    totaal: number;
    klaar: number;
    fouten: number;
    bezig: number;
    zonder_geocoding: number;
    vandaag: number;
}

const fmt = (n: number) => n.toLocaleString('nl-NL');

const StatusFooter = () => {
    const [stats, setStats] = useState<BestekStats | null>(null);

    useEffect(() => {
        apiService.get<BestekStats>('/bestek/stats')
            .then(r => setStats(r.data))
            .catch(() => {});

        const interval = setInterval(() => {
            apiService.get<BestekStats>('/bestek/stats')
                .then(r => setStats(r.data))
                .catch(() => {});
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    if (!stats) return null;

    const vandaagTekst = stats.vandaag === 0
        ? 'Er zijn vandaag geen bestekken geüpload'
        : `Er zijn vandaag ${fmt(stats.vandaag)} bestekken geüpload`;

    return (
        <div style={{
            borderTop: '1px solid #f0f0f0',
            padding: '10px 0',
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            fontSize: '11px',
            color: '#adb5bd',
        }}>
            <span>{vandaagTekst}</span>
            <span>·</span>
            <span>De applicatie is bij</span>
        </div>
    );
};

export default StatusFooter;
